
<template>

    <span ref="Element" :class="{'Disabled':FinalEnabled!=true}"
          v-show="FinalVisible"
          :nullable="!(FinalRequired)+''"
          :value="m_Text!=null?m_Text:''"
          DataType="Date">
         
        <template v-if="!FinalEnabled">
            <t-label v-model="m_Text" DataType="Date" style="border:1px solid #D0D0D0;width:130px;display:inline-block;height:35px;background-color:#f5f5f5;padding-left:5px;line-height:33px"></t-label>
        </template>
        <template v-else>
            <date-pick v-show="FinalVisible"
                       v-model="m_Text"
                       v-on:input="OnValueChange"
                       :months="months"
                       :weekdays="weekdays"
                       :format="'YYYY/MM/DD'"
                       :title="Title"
                       :disabled="(!FinalEnabled)"></date-pick>

        </template>


        <span class="error_message" v-if="ErrorMessage">{{ErrorMessage}}</span>
    </span>

</template>

<script>
    import Utility from '@/Common/Utility'
    import DatePick from 'vue-date-pick';
    import 'vue-date-pick/dist/vueDatePick.css';
    import Validator from '@/Common/Validator'
    import TControlBase from '../Common/TControlBase';

    export default {
        data() {
            return {
                m_Value: null,
                m_Text:"",
                Title: "",
                ErrorMessage:"",
                nextMonthCaption: { type: String, default: '下一月' },
                prevMonthCaption: { type: String, default: '前一月' },
                setTimeCaption: { type: String, default: '設定時間:' },
                weekdays: [
                    '一', '二', '三', '四', '五', '六', '日'
                ]
                ,
                months: [
                    '一月', '二月', '三月', '四月',
                    '五月', '六月', '七月', '八月',
                    '九月', '十月', '十一月', '十二月'
                ],

                m_Attribute: TControlBase.Attribute({
                    Enabled: true,
                    Nullable: true,
                    Visible: true,
                    DataType: "Date"
                    }
                ),
            }
        }
        ,
        props: [...TControlBase.BaseProps],


        computed: { 
        }
        ,


        methods: {

            GetDateText() {
                let dateText = "";

     
                return dateText;
            },

            OnValueChange(e) {
                let resultValue = null;
                let result;
                 

                this.ErrorMessage = "";

                this.$forceUpdate();

                if (this.IsValidate(this.m_Text)) {

                    this.ClearError();

                    if (this.Validator != null) {
                        result = this.Validator(this.m_Text,this);

                        if (result.Success != true) {
                            this.ErrorMessage = result.Message;
                        }
                    }

                    resultValue = this.m_Text;
                    this.m_Value = resultValue;

                    //resultValue = this.m_Value;

                //    this.$emit("input", this.date);
                //    this.$emit("change", this.date);
                    this.$emit("input", resultValue);
                    this.$emit("change", resultValue);

                    this.ClearError();
                }
                else {
                    if (this.m_Attribute.Required) {
                        setTimeout( 
                            () => {
                                this.ClearError();
                                this.DoValidate();
                            },
                            30
                        );
                    }

                    this.$emit("input", null);
                    this.$emit("change", null);
                }

                
                //this.$emit("input", resultValue);
                //this.$emit("change", resultValue);
            },


            IsValidate(dateText) {
                let validated = false;
                var dateRegex = /^\d{4}\/\d{1,2}\/\d{1,2}$/;

                validated = dateRegex.test(dateText);

                return validated;
            },

            UpdateElementByAttribute() {
                let inputElement;
                let i;


                inputElement = this.$refs.Element.querySelector(".vdpWithInput > INPUT");

                if (inputElement != null) {
                    if (this.m_Attribute.Enabled == false) {

                        inputElement.setAttribute("disabled", "disabled");

                    }
                    else {
                        inputElement.removeAttribute("disabled");
                    }

                    //inputElement.setAttribute("nullable", this.Nullable);
                    //inputElement.setAttribute("DataType", "DateTime");
                    inputElement.classList.add("Date");

                    inputElement.addEventListener("change",
                        function (e) {
                            Validator.OnElementChange(e);
                        }.bind(Validator)
                    );
                }
            },


            GetDateStr(dateTime) {
                var dateStr;
                var year, month, day;
                var hour, minute, second;

                if (dateTime == null)
                    dateTime = new Date();
                else
                    dateTime = new Date(dateTime);

                month = dateTime.getMonth() + 1;
                day = dateTime.getDate();

                if (month.toString().length == 1)
                    month = "0" + month;
                if (day.toString().length == 1)
                    day = "0" + day;

                hour = dateTime.getHours();
                minute = dateTime.getMinutes();
                second = dateTime.getSeconds();

                if (hour.toString().length == 1)
                    hour = "0" + hour;
                if (minute.toString().length == 1)
                    minute = "0" + minute;
                if (second.toString().length == 1)
                    second = "0" + second;


                if ((year = dateTime.getYear()) < 200)
                    year += 1900;

                /*
                  dateStr = year + "/" +
                            month + "/" + day + " " +
                            hour + ":" + minute + ":" + second;
                  */

                dateStr = year + "/" + month + "/" + day;

                return dateStr;
            }
        },

        mounted() {
            let inputElement;

            inputElement = this.$refs.Element.querySelector(":scope .vdpComponent.vdpWithInput input[type='text']");


            if (this.Title != null) {
                if (inputElement != null) {
                    inputElement.setAttribute("title", this.Title);
                }
            }

        },

        created() {

            TControlBase.call(this);
    

            //if (this.value != "" && this.value != null && !isNaN(this.value)) {
            //    this.date = this.GetDateStr(this.value);
            //}
            //else {
            //    if (this.value != null && Utility.IsIso8601Text(this.value)) {

            //        this.date =
            //            Utility.GetDateText(
            //                Utility.ConvertIso8601TextToDate(this.value)
            //            );
            //    }
            //    else {
            //        this.date = this.value;
            //    }
            //}


            //if (this.nullable != null) {
            //    if ((this.nullable + "").toLowerCase() == "false") {
            //        this.m_Attribute.Nullable = false;
            //    }
            //    else {
            //        this.m_Attribute.Nullable = true;
            //    }
            //}

            //if (this.title != null) {
            //    this.Title = this.title;
            //}


            //if (this.disabled == true || this.disabled == "true") {
            //    this.m_Attribute.Enabled = false;
            //}
            //else {
            //    this.m_Attribute.Enabled = true;
            //}

            //if (this.disabled == null) {
            //    if (this.Enabled == true || this.Enabled == "true" || this.Enabled == null) {
            //        this.m_Attribute.Enabled = true;
            //    }
            //    else {
            //        this.m_Attribute.Enabled = false;
            //    }
            //}

            setTimeout(
                function () {
                    this.UpdateElementByAttribute();
                }.bind(this),
                1
            );
        },

        watch: {
             
            //value: function (newVal, oldVal) {
            //    let dateTimeObj;

            //    if (newVal != null && newVal != "") {
            //        dateTimeObj = Date.parse(newVal + "");

            //        if (!isNaN(dateTimeObj)) {
            //            this.date = this.GetDateStr(newVal);
            //        }
            //        else {
            //            this.date = newVal;
            //        }
            //    } else {
            //        this.date = newVal;
            //    }
            //},

            //nullable: function(newVal) { 

            //    if (newVal != null) {
            //        if ((newVal+'').toLowerCase() == "false") {
            //            this.m_Attribute.Nullable = false;
            //        }
            //        else {
            //            this.m_Attribute.Nullable = true;
            //        }

            //        this.$forceUpdate();
            //    }
            //},

            //Attribute: function (newVal) {
            //    Utility.SetNotNullAttributes(this.m_Attribute, newVal);
            //    this.UpdateElementByAttribute();
            //},

            //DataType: function (newVal) {
            //    this.m_Attribute.DataType = newVal;
            //},
        }
        ,

        components: {
            "date-pick": DatePick
        }

    }
</script>

<style scoped>

    SPAN[disabled] .vdpComponent.vdpWithInput {
    }
</style>
